/**
 * Homepage / customers-page testimonials — Phase 92 (site audit fix D3.2).
 *
 * The audit flagged first-name-only, photo-less testimonials as thin
 * social proof. Cards now support richer attribution rendered only when
 * the field is filled:
 *   img    — headshot URL (square)
 *   school — the coach's swim school name
 *   handle — @instagram or facebook handle
 *
 * TODO(owner): contact Marina K., Jordan T., and Rio M. to collect a
 * headshot, school name, @handle, and written permission — then fill the
 * empty fields below. If any are Pro coaches with gallery cards, we can
 * also link the testimonial to their coach page.
 */
export const TESTIMONIALS = [
    {
        q: '“I replaced 3 tools and a stack of paper waivers with SplashPad in a weekend.”',
        a: 'Marina K.',
        r: 'Bay Area, CA',
        img: '',
        school: '',
        handle: '',
    },
    {
        q: '“Parents love the registration flow. I love that I never chase payment again.”',
        a: 'Jordan T.',
        r: 'Austin, TX',
        img: '',
        school: '',
        handle: '',
    },
    {
        q: '“SplashPad paid for itself in the first month. Tripled my enrollment in 6 months.”',
        a: 'Rio M.',
        r: 'Miami, FL',
        img: '',
        school: '',
        handle: '',
    },
];
